import { ClassNameProps, makeClassName, StyleProps } from "@hex-insights/core";
import { Badge } from "../../../../Components/Badge";
import { CalendarEvent } from "../../../../Utilities";
import { CalendarEventFormat } from "../../../Format";
import styles from "./styles.module.css";

export type CalendarEventStatusBadgeProps = {
	calendarEvent: Pick<CalendarEvent, "startTime" | "endTime" | "startDate" | "endDate">;
} & Partial<ClassNameProps & StyleProps>;

export function CalendarEventStatusBadge({ calendarEvent, className, style }: CalendarEventStatusBadgeProps) {
	const status = CalendarEventFormat.status(calendarEvent);

	switch (status) {
		case "Now":
			return (
				<Badge
					color="#fff"
					backgroundColor="var(--theme-colors__green)"
					className={makeClassName(styles["status-badge"], className)}
					style={style}
				>
					{status}
				</Badge>
			);
		case "Upcoming":
			return (
				<Badge
					color="#fff"
					backgroundColor="var(--theme-colors__blue)"
					className={makeClassName(styles["status-badge"], className)}
					style={style}
				>
					{status}
				</Badge>
			);
		case "Past":
			return (
				<Badge
					color="#fff"
					backgroundColor="var(--neutral-colors--tertiary)"
					className={makeClassName(styles["status-badge"], className)}
					style={style}
				>
					{status}
				</Badge>
			);
	}
}
